<template>
  <div id="hres82e-room-detail" class="hres82e-room-detail box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border collapsed">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i> 
            {{ labels['HRES82EC4']['10']}}
          </h3>
        </div>
        <div class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
          	<div class="col-md-4 panel-left">
          		<img src="../../assets/img/meetingroom.jpg" style="width: 100%">
          	</div>
          	<div class="col-md-8 form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRES82EC4']['100'] }}</label>
                <div class="col-sm-9">
                  <div class="radio col-xs-6">
                    <label>
                      <input type="radio" disabled="disabled" value="A" v-model="detail.status">
                      {{ labels['HRES82EC4']['120'] }} 
                    </label>
                  </div>
                  <div class="radio col-xs-6">
                    <label>
                      <input type="radio" disabled="disabled" value="C" v-model="detail.status">
                      {{ labels['HRES82EC4']['130'] }} 
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRES82EC4']['20'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.roomno">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRES82EC4']['30'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.desc_roomno">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRES82EC4']['40'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.floor">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRES82EC4']['50'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.building">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRES82EC4']['60'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.qtypers + ' ' + labels['HRES82EC4']['70']">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRES82EC4']['80'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.accessori">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRES82EC4']['90'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.remark">
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label">{{ labels['HRES82EC4']['110'] }}</label>
                <div class="col-sm-9">
                  <input type="input" readonly="readonly" class="form-control" :value="detail.codrespon + ' ' + detail.desc_codrespon">
                </div>
              </div>
          	</div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-footer">
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>
  </div>
</template>

<script>
export default {
  name: 'hres82e-room-detail',
  props: [ 'labels', 'detail', 'labelsButton', 'toggle', 'data', 'nowLang' ]
}
</script>


// WEBPACK FOOTER //
// roomDetail.vue?354fdf44